import * as React from 'react';
import Footer from '../../components/footer/Footer';

import '../../assets/style.css';
import '../../assets/style_home.css';
import Section from '../../components/section/Section';
import { greetings } from '../../data/greetings';
import {lectors} from '../../data/lectors';
import ImageLink from '../../components/layouts/ImageLink';
import Slider from '../../components/slider/Slider';
import { Link } from 'react-router-dom';
import Navbar from '../../components/nav/Navbar';
import { CalendarMonth, Circle, LocationOn } from '@mui/icons-material';
import Counter from '../../components/counter/Counter';
import {isBrowser, isMobile } from 'react-device-detect';
import Circles from '../../components/aesthetics/Circles';
import logo_long from '../../assets/logo/logo_long.svg';

export default function Home(){


    return (
        <>
            <Navbar/>
    <div className="flex-column fullheight">
        <div id="title-image-wrap">
            <div id="title-image">
            
                <div id="title-cover">
		    <div><Circles/> </div>
		    
                    <div id="poster-title" className="flex-column-center-2 section-padded-large">
			<div style={{textAlign:"left"}}>

                            <p style={{fontFamily:'Cormorant Garamond Semibold'}} className="page-title-text">
			    Mentalno zdravlje za sve:</p>
			    <p className="page-title-text" style={{fontFamily:'Cormorant Garamond Italic'}}> uloga psihologije u dostupnoj i kvalitetnoj podršci</p>
			</div>
			<div style={{textAlign:"left", width:"100%"}}>
			    <div style={{width:"20vw"}}><img src={logo_long}/></div>
			<p id="poster-subtitle">Prijavite se na godišnju konferenciju: </p>
			    <div className="flex-row" style={{justifyContent:"left", gap:"1rem", paddingTop:"1rem"}}>
                            
			    <Link to="/prijava-sudjelovanja"><button className="pillbox button">Prijava sudjelovanja</button></Link>
			    <Link to="/prijava-sazetaka" target="_blank"><button className="pillbox button">Prijava sažetka</button></Link>
			</div>
			    </div>
			<div style={{width:"100%"}}><Counter goalDate={new Date("2026-11-4 17:00")}/></div>
			
		    </div>
		</div>
            </div>
        </div>

        <Section className="section-padded-standard-bottom-heavy background-opaque" title={<h1 className='section-title-font section-title-font-alt-padding'>Dobrodošli na 33. godišnju konferenciju hrvatskih psihologa!</h1>}  
        content={
            <>
            <div  className='section-content-font-large' style={{maxWidth:"60%", margin:"auto", textAlign:"center"}}>
                <p style={{paddingBottom:"2rem", fontFamily:"Cormorant Garamond Regular"}}>Pridružite nam se na godišnjoj konferenciji i podijelite svoje uvide na temu:</p>
		<div> <span style={{fontFamily:"Cormorant Garamond Semibold"}}>Mentalno zdravlje za sve:</span><span style={{fontFamily:"Cormorant Garamond Italic"}}> uloga psihologije u dostupnoj i kvalitetnoj podršci</span></div>
                <br/>
            </div>
            </>
        } />
        <div className="background-opaque section-padded-small" style={{paddingTop:"6rem"}}>
        <Section title={<h1 className='section-title-font'>Pozdravne riječi organizatora</h1>} 
        content={
            <div className={(isMobile?"flex-column":"flex-row")+" flex-centered section-padded-standard"} style={{justifyContent:"center", gap:"10rem", paddingTop:"2rem", paddingBottom:"4rem", margin:"auto", width:"100%", alignItems:'center'}}>
                {
                Object.keys(greetings).map((key, index)=>{
                    let person = greetings[key];
                    return <div key={key}  style={{width:isMobile?"80%":"20%"}}><ImageLink title={person.title} button={false} name={person.name} description={person.description} link={person.link}  image={person.image_vert} reverse={false}/></div>
                })
        }
            </div>
        } />
        </div>
                <div className="background-opaque section-padded-small" style={{paddingBottom:"6rem"}}>
        <Section title={<h1 className='section-title-font'>Pozvani predavači</h1>} 
        content={<>
            <div className={(isMobile?"flex-column":"flex-row")+" flex-centered "} style={{justifyContent:"center", gap:"3rem", flexWrap:"wrap", paddingTop:"2rem", paddingBottom:"4rem", width:"100%", alignItems:'center'}}>
                {
                    Object.keys(lectors).slice(0,3).map((key, index)=>{
                        let lector = lectors[key]
			return <div key={key}  style={{width:isMobile?"75%":"20%"}}><ImageLink link={lector.link} button={false} title={lector.title}  name={lector.name} description={lector.description} image={lector.image_vert}></ImageLink></div>
                })
            }
            </div>
            <div className={(isMobile?"flex-column":"flex-row")+" flex-centered "} style={{justifyContent:"center", gap:"3rem", flexWrap:"wrap", addingBottom:"4rem", width:"100%", alignItems:'center'}}>
                {
                Object.keys(lectors).slice(3).map((key, index)=>{
                    let lector = lectors[key]
                return <div key={key}  style={{width:isMobile?"75%":"20%"}}><ImageLink link={lector.link} button={false} title={lector.title}  name={lector.name} description={lector.description} image={lector.image_vert}></ImageLink></div>
            })
            }
            </div>
            </>
        } />
        </div>
        <div id="pregled" className="background-opaque">
            <div className='section-padded-standard'>
        <Section contentStyle={{paddingTop:"3vh", paddingBottom:"15vh", display:"flex", flexDirection:"column", gap:"1.5rem"}} 
        content={
            <>
                <h1 className='section-title-font' style={{fontWeight:"400", fontFamily:"Cormorant Garamond Italic"}}>Zajedno oblikujmo budućnost psihologije!</h1>
            <p style ={{fontFamily: 'Cormorant Garamond Semibold', fontSize:isMobile?"1.8":"2.2rem"}}> 4. - 7. studenog 2026. Hotel Olympia, Vodice</p>
            <div className='flex-row' style={{gap:"1rem", justifyContent:"center"}}>
                <Link to="/prijava-sudjelovanja"><button className="pillbox button button-huge button-color-trans-dark">Prijava sudjelovanja</button></Link>
                <Link to="/prijava-sazetaka"><button className="pillbox button button-huge button-color-trans-dark">Prijava sažetaka</button></Link>
            </div>
            </>
        } />
        </div>
        
        </div>
        <div id="dates" className="background-opaque section-padded-large">
        <Section title={<h1 className='section-title-font'><span className=''>Važni</span> datumi</h1>} 
        content={
        <div className="flex-column" style={{width: isMobile?"95%":"40%", margin:"auto", gap:"1rem", fontFamily: 'Aboreto Regular', fontSize:isMobile?"1.0rem":"1.6rem"}}>
            <div className="flex-row" style={{justifyContent:"space-between",}}>
            <p>Rana kotizacija</p>
            <p>do 31.7.2026</p>
            </div>
            <div className="flex-row" style={{justifyContent:"space-between",}}>
            <p>Srednja kotizacija</p>
            <p>od 1.8.2026 do 18.10.2026</p>
            </div>
            <div className="flex-row" style={{justifyContent:"space-between",}}>
            <p>Kasna kotizacija</p>
            <p>od 19.10.2026 do 3.11.2026</p>
            </div>
            <div className="flex-row" style={{justifyContent:"space-between",}}>
            <p>Prijava sažetaka</p>
            <p>do 10.9.2026</p>
            </div>

        </div>
        
        
        } />
        </div>
        <div>
        <Footer/>
        </div>
    </div>
    </>
    )
}
